import { ProfileRole } from "src/app/models/profile-role";

export interface IInviteMemberModel {
    email: string;
    role: string;
}
export interface IInviteMemberError {
    email: string[];
    role: string[];
}

export class InviteMember {
    email: string;
    role: ProfileRole;

    error: IInviteMemberError;

    constructor(role) {
        this.email = null;
        this.role = role;

        this.resetInviteError();
    }

    resetInviteError() {
        this.error = {
            email: [],
            role: [],
        }
    }

    isInviteDataValid() {
        this.resetInviteError();

        if (this.email == null || this.email == '') {
            this.error.email = ['Email is required']
        }
        if (this.role == null) {
            this.error.role = ['Role is required']
        }

        return this.error.email.length == 0 &&
            this.error.role.length == 0
    }

    getInvitePayload(): IInviteMemberModel {
        return {
            email: this.email,
            role: this.role.id,
        }
    }
}